import { useEffect, useRef } from "react"

/**
 * Monospace auto-scrolling log viewer, shared between ServerConsolePage
 * and ServerLogsPage (both read the same Crafty log buffer, see
 * routes/console.ts's doc comment on why there's only one data source).
 */
export function LogView({ lines }: { lines: string[] }) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = containerRef.current
    if (el) el.scrollTop = el.scrollHeight
  }, [lines])

  return (
    <div
      ref={containerRef}
      style={{
        fontFamily: "var(--font-mono, ui-monospace, monospace)",
        fontSize: "var(--text-sm)",
        lineHeight: 1.6,
        background: "var(--bg-primary)",
        border: "1px solid var(--border-default)",
        borderRadius: "var(--radius-md)",
        padding: "var(--space-4)",
        height: "50vh",
        minHeight: 280,
        overflowY: "auto",
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
      }}
    >
      {lines.length === 0 ? (
        <span style={{ color: "var(--text-muted)" }}>Sin salida todavía.</span>
      ) : (
        lines.map((line, i) => (
          <div key={i} style={{ color: "var(--text-primary)" }}>
            {line}
          </div>
        ))
      )}
    </div>
  )
}
